export default __webpack_public_path__ + "static/media/poster-teaser.d361a32e.png";